export default __webpack_public_path__ + "media/images/onglet-droite2-72b1e0fa1b6e0640f0e91d64d1ae693b.png";